import { FAMILIES } from "../../shared/model";
import { Shell } from "../ui/Shell";
import { PuzzleCard } from "../ui/PuzzleCard";
import { Link } from "../app/router";
import { useStore } from "../app/store";
import { dayKey } from "../app/clock";
import { dailyId, rungId } from "../../shared/model";
import { FAMILY_META, LEVEL_NAMES, rungCount } from "../puzzles/catalog";

export default function Puzzles() {
  const day = dayKey();
  const progress = useStore((d) => d.progress);
  return (
    <Shell>
      <div className="wrap shelf">
        <header className="page-head">
          <p className="kicker">The shelf</p>
          <h1>Every puzzle, in your own order.</h1>
          <p className="lede muted">Each family starts with a short ladder of hand-picked puzzles. When you reach the top, fresh ones appear every day at whatever level you choose.</p>
        </header>

        {FAMILIES.map((f) => {
          const meta = FAMILY_META[f];
          return (
            <section key={f} className="family-section" id={f}>
              <div className="family-head">
                <span className={"chip " + meta.muscle.toLowerCase()}>{meta.muscle}</span>
                <h2>{meta.name}</h2>
                <p className="muted">{meta.pitch} <em>{meta.skill}</em></p>
              </div>
              <h3 className="sub-head">The ladder</h3>
              <div className="card-grid">
                {Array.from({ length: rungCount(f) }, (_, i) => <PuzzleCard key={i} id={rungId(f, i + 1)} />)}
              </div>
              <h3 className="sub-head">Fresh puzzles for today</h3>
              <div className="level-row">
                {Array.from({ length: meta.maxDifficulty }, (_, i) => {
                  const id = dailyId(f, day, i + 1);
                  const st = progress[id]?.status;
                  return (
                    <Link key={id} to={"/p/" + id} className={"level-pill" + (st === "solved" ? " solved" : "")}>
                      <span className="lp-n">{i + 1}</span>
                      <span>{LEVEL_NAMES[i]}</span>
                      {st === "solved" && <span aria-label="solved">✓</span>}
                    </Link>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    </Shell>
  );
}
